import { NodePreviewForm } from 'components/form/trident-campaigns';
import _ from 'lodash';
import React, { Component } from 'react';
import { Accordion, Icon } from 'semantic-grab-ui/src';
import type { City, Country } from 'types/country';
import type { TridentCampaignDetails } from 'types/trident-campaigns';

interface Props {
  model: TridentCampaignDetails;
  cities: City[];
  country: Country;
  canActivate: boolean;
  currentKey: string;
  handleNodePreview: () => void;
  parentKeyList: string[];
  onModelChange: (_?: object) => void;
  handleDeleteNode: () => void;
  handleAddNode: () => void;
  handleDuplicateBranch: () => void;
  addDefaultExperiment: () => void;
  clickedScenarioIndex: number;
  listRuleTypes: object;
  showModal: boolean;
  nodeType: string;
  closeModal: () => void;
  openModal: () => void;
  scenarioIndex: number;
  autoShowHistorySearch: object | null;
  clearAutoShowHistorySearch: () => void;
}

interface State {
  activeIndex: number;
}

export default class NodePreview extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const activeIndex = this.props.parentKeyList.indexOf(this.props.currentKey);
    this.state = {
      activeIndex,
    };
  }
  handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? activeIndex : index;
    this.setState({
      activeIndex: newIndex,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.currentKey !== this.props.currentKey) {
      const activeIndex = nextProps.parentKeyList.indexOf(nextProps.currentKey);
      this.setState({
        activeIndex,
      });
    }
  }

  render() {
    const accordionStyle = {
      width: 400,
    };
    const borderStyleToScenario = {
      borderLeftStyle: 'solid',
      borderLeftColor: '#fdd594',
    };
    const borderStyleToCondition = {
      borderLeftStyle: 'solid',
      borderLeftColor: '#b6e3fe',
    };
    const borderStyleToTime = {
      borderLeftStyle: 'solid',
      borderLeftColor: '#fcbbb4',
    };
    const borderStyleToAction = {
      borderLeftStyle: 'solid',
      borderLeftColor: '#debefc',
    };
    const borderStyleToCounter = {
      borderLeftStyle: 'solid',
      borderLeftColor: '#89e8de',
    };
    const borderStyleToCountCondition = {
      borderLeftStyle: 'solid',
      borderLeftColor: '#d2f5ae',
    };
    const borderStyleToDelay = {
      borderLeftStyle: 'solid',
      borderLeftColor: '#76D7C4',
    };
    const borderStyleMap = {
      scenarios: borderStyleToScenario,
      time: borderStyleToTime,
      condition: borderStyleToCondition,
      actions: borderStyleToAction,
      count: borderStyleToCounter,
      countCondition: borderStyleToCountCondition,
      delay: borderStyleToDelay,
    };
    const { activeIndex } = this.state;
    const { model, parentKeyList, canActivate } = this.props;
    // -1 for scenario and time nodes because they won't have their parents.
    const parentNodeOfCurrentNode = (parentKeyList.length >= 2) ? parentKeyList[this.state.activeIndex - 1] : '-1';
    return (
      <div>
        <Accordion styled style={accordionStyle}>
          {parentKeyList.map((keyOfNode, index) => {
            return (
              <div key={keyOfNode}>
                <Accordion.Title active={activeIndex === index} index={index} onClick={this.handleClick} style={borderStyleMap[_.get(model.nodes[keyOfNode], 'type', '')]} key={`${index}${'title'}`}>
                  <Icon name="dropdown" />
                  {_.get(model.nodes[keyOfNode], 'type', '')}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index} style={borderStyleMap[_.get(model.nodes[keyOfNode], 'type', '')]} key={`${index}_content`}>
                  <NodePreviewForm
                    activeIndex={this.state.activeIndex}
                    key={`${index}_nodePreview`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    cities={this.props.cities}
                    country={this.props.country}
                    canActivate={canActivate}
                    currentNodeToDisplay={parentKeyList[activeIndex]}
                    handleDeleteNode={this.props.handleDeleteNode}
                    parentNode={parentNodeOfCurrentNode}
                    parentKeyList={parentKeyList}
                    clickedScenarioIndex={this.props.clickedScenarioIndex}
                    listRuleTypes={this.props.listRuleTypes}
                    handleAddNode={this.props.handleAddNode}
                    handleDuplicateBranch={this.props.handleDuplicateBranch}
                    showModal={this.props.showModal}
                    closeModal={this.props.closeModal}
                    nodeType={this.props.nodeType}
                    openModal={this.props.openModal}
                    scenarioIndex={this.props.scenarioIndex}
                    addDefaultExperiment={this.props.addDefaultExperiment}
                    autoShowHistorySearch={this.props.autoShowHistorySearch}
                    clearAutoShowHistorySearch={this.props.clearAutoShowHistorySearch}
                  />
                </Accordion.Content>
              </div>
            );
          })}
        </Accordion>
      </div>
    );
  }
}
